"use client";

function readCookie(name: string): string {
  if (typeof document === "undefined") return "";
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : "";
}

/**
 * Ad-platform key → first-party cookie(s) it is read from, first hit wins.
 * Click ids come from the `_mdb_*` cookies the middleware sets on landing;
 * the rest are browser refs the platforms' own pixels write.
 */
const AD_ID_COOKIES: Array<[string, string[]]> = [
  ["fbclid", ["_mdb_fbclid"]],
  ["fbc", ["_fbc"]],
  ["fbp", ["_fbp"]],
  ["gclid", ["_mdb_gclid"]],
  ["gbraid", ["_mdb_gbraid"]],
  ["wbraid", ["_mdb_wbraid"]],
  ["ga", ["_ga"]],
  ["ttclid", ["_mdb_ttclid"]],
  ["ttp", ["_ttp"]],
  ["epik", ["_mdb_epik", "_epik"]],
  ["oppref", ["_mdb_oppref", "__oppref"]],
  ["obref", ["__obref"]],
];

/** Snapshot of every ad identifier cookie plus the user agent. */
export function readAdIdentifierCookies(): Record<string, string> {
  const ids: Record<string, string> = {};
  for (const [key, names] of AD_ID_COOKIES) {
    for (const name of names) {
      const v = readCookie(name);
      if (v) {
        ids[key] = v;
        break;
      }
    }
  }
  if (typeof navigator !== "undefined") ids.user_agent = navigator.userAgent;
  return ids;
}

/**
 * Re-reads the cookies pixels write late (_fbc/_fbp from Meta, __obref from
 * ChatGPT Ads) at SEND time and merges them over the mount-time snapshot,
 * synthesizing fbc from the click id when the pixel still hasn't written _fbc.
 * This is what lets the persisted Order.ad_identifiers (and thus the purchase
 * CAPI events) carry the pixel's exact values instead of empty ones. The
 * stable click ids (fbclid/gclid/oppref/…) come from the snapshot.
 */
export function freshenAdIds(base: Record<string, string>): Record<string, string> {
  const out: Record<string, string> = { ...base };
  for (const [key, cookie] of [["fbc", "_fbc"], ["fbp", "_fbp"], ["obref", "__obref"]]) {
    const v = readCookie(cookie);
    if (v) out[key] = v;
  }
  if (!out.fbc && out.fbclid) out.fbc = `fb.1.${Date.now()}.${out.fbclid}`;
  return out;
}
